module.exports = __webpack_public_path__ + "img/clogo.df6ab568.png";